import React from "react";

const ImageGridCard = ({ item, styles }) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const coloum_value = JSON.parse(item?.coloum_value);

  return (
    <div>
      <div className="grid grid-cols-2 gap-[11px] md:gap-[30px]">
        {coloum_value?.map((image, i) => {
          return (
            <div key={i}>
              <img
                src={`${image ? baseUrl + "/profile/" + image : ""}`}
                className="md:min-w-[330px] md:min-h-[330px] md:w-[330px] md:h-[330px] md:max-w-[330px] md:max-h-[330px]   min-w-[125px] min-h-[125px] w-[125px] h-[125px] max-w-[125px] max-h-[125px] rounded-lg object-cover"
                alt="..." title="Image"              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageGridCard;
